import { render, staticRenderFns } from "./OrderButtons.vue?vue&type=template&id=64c37b3a"
import script from "./OrderButtons.vue?vue&type=script&lang=js"
export * from "./OrderButtons.vue?vue&type=script&lang=js"
import style0 from "./OrderButtons.vue?vue&type=style&index=0&id=64c37b3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports